/**
 * BETA5 CHOCOLATES — Bundle Cart Attribute Generator
 * bundle-cart-note.js
 *
 * Runs on the cart page. Reads live cart data, finds bespoke bundle
 * parents, and writes a fulfillment-ready summary into a cart ATTRIBUTE
 * (not the customer-facing note field).
 *
 * Cart attributes are invisible to the customer on the cart page but
 * appear in Shopify order admin under "Additional details" and are
 * accessible in packing slip templates.
 *
 * Cart Transform "expand" strips the parent box from packing slip data,
 * so this attribute is how the fulfillment team sees box compositions.
 *
 * Install:
 *   1. Upload to assets/bundle-cart-note.js
 *   2. Add to your cart template (e.g. sections/main-cart.liquid):
 *      <script src="{{ 'bundle-cart-note.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  var ATTR_KEY = 'Bespoke Order Details';

  function init() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bundleNote = buildBundleNote(cart.items);
        var currentAttr = (cart.attributes && cart.attributes[ATTR_KEY]) || '';

        // Only update if the value actually changed
        if (bundleNote === currentAttr) return;

        var attrs = {};
        attrs[ATTR_KEY] = bundleNote;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(function () {
          // Inject or update a hidden input in the cart form so the
          // attribute survives form submission (same pattern the theme
          // already uses for collection_mobile_items_per_row, etc.)
          syncHiddenInput(bundleNote);
        });
      })
      .catch(function (err) {
        console.warn('[Beta5 Bundle Note] Error:', err);
      });
  }

  /**
   * Inject a hidden input into the cart form so the attribute value
   * is included when the form submits to checkout.
   */
  function syncHiddenInput(value) {
    var form = document.querySelector('form[action="/cart"]');
    if (!form) return;

    var inputName = 'attributes[' + ATTR_KEY + ']';
    var existing = form.querySelector('input[name="' + inputName + '"]');

    if (existing) {
      existing.value = value;
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      input.value = value;
      form.appendChild(input);
    }
  }

  /**
   * Build the bundle summary string from cart items.
   * Returns empty string if no bespoke boxes in cart.
   */
  function buildBundleNote(items) {
    var parents = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var props = item.properties || {};
      if (props._bundle_parent !== 'true') continue;

      parents.push({
        boxSize: props._box_size || '?',
        quantity: item.quantity,
        subPref: props['If Unavailable'] || '',
        chocolates: extractChocolates(props)
      });
    }

    if (parents.length === 0) return '';

    var blocks = [];
    for (var p = 0; p < parents.length; p++) {
      var parent = parents[p];
      var header = '<strong>' + parent.boxSize + 'PC BESPOKE BOX</strong>';
      if (parent.quantity > 1) {
        header += ' <span class="ps-qty-badge">×' + parent.quantity + '</span>';
      }

      var lines = [header];

      var flavors = groupFlavors(parent.chocolates);
      for (var f = 0; f < flavors.length; f++) {
        lines.push(flavors[f].count + ' x ' + flavors[f].name);
      }

      if (parent.subPref) {
        lines.push('<span class="ps-sub-pref">⚠ If Unavailable: ' + parent.subPref + '</span>');
      }

      blocks.push(lines.join(' | '));
    }

    return blocks.join(' || ');
  }

  /**
   * Extract chocolate names from _Chocolate properties.
   */
  function extractChocolates(props) {
    var names = [];
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('Chocolate') !== -1) {
        names.push(props[keys[i]]);
      }
    }
    return names;
  }

  /**
   * Group and count duplicate flavor names.
   */
  function groupFlavors(names) {
    var seen = {};
    var order = [];
    for (var i = 0; i < names.length; i++) {
      var name = names[i];
      if (seen[name]) {
        seen[name]++;
      } else {
        seen[name] = 1;
        order.push(name);
      }
    }
    var result = [];
    for (var j = 0; j < order.length; j++) {
      result.push({ name: order[j], count: seen[order[j]] });
    }
    return result;
  }

  // Run on DOM ready (script is deferred, so DOM is ready)
  init();

})();